import axios from "axios";
import { BASE_URL } from ".";
import { StyleTemplate } from "../components/PaperEditor/Export/ExportProcess.tsx";

export interface Author {
  name: string;
  affiliation: string;
  email?: string;
  orcid?: string;
}

export interface TemplateAdditionalInfoField {
  key: string;
  label: {
    en: string;
    zh: string;
  };
  type: string;
  required: boolean;
  default: string;
  placeholder: {
    en: string;
    zh: string;
  };
  description: string;
  ui: {
    widget: string;
    size: string;
  };
  value: string;
}

export interface TemplateAdditionalInfo {
  version: string;
  fields: TemplateAdditionalInfoField[];
}

export interface GetTemplateAdditionalInfoResponse {
  message: string;
  id: string;
  data: TemplateAdditionalInfo;
}

export interface SaveTemplateAdditionalInfoResponse {
  message: string;
  data: TemplateAdditionalInfo;
}

class ExportService {
  /**
   * 获取最近导出的历史记录
   */
  public static async getRecentExportHistory(paperId: string): Promise<{ title: string; templateName: string; exportDate: string }[]> {
    const response = await axios.get(BASE_URL + "/edit-api/paper/export/history", {
      params: {
        paperId
      }
    });
    return response.data;
  }

  /**
   * 获取所有模板
   */
  public static async getAllTemplates(): Promise<StyleTemplate[]> {
    const response = await axios.get(BASE_URL + "/edit-api/paper/export/all-templates");
    return response.data;
  }

  /**
   * 获取作者列表
   * @param paperId
   */
  public static async getAuthorList(paperId: string): Promise<{ name: string; id: string }[]> {
    const response = await axios.get(BASE_URL + "/edit-api/paper/export/author-list", {
      params: {
        paperId
      }
    });
    return response.data;
  }

  /**
   * 获取或创建模板附加信息
   * @param paperId 论文ID
   * @param templateId 模板ID
   */
  public static async getTemplateAdditionalInfo(
    paperId: string,
    templateId: number
  ): Promise<GetTemplateAdditionalInfoResponse> {
    const response = await axios.post(BASE_URL + "/edit-api/paper/export/get-template-additional-info", {
      paperId,
      templateId
    });
    return response.data;
  }

  /**
   * 保存模板附加信息
   * @param additionalInfoUuid 附加信息UUID
   * @param userData 用户数据
   */
  public static async saveTemplateAdditionalInfo(
    additionalInfoUuid: string,
    userData: Record<string, string>
  ): Promise<SaveTemplateAdditionalInfoResponse> {
    const response = await axios.post(BASE_URL + "/edit-api/paper/export/save-template-additional-info", {
      id: additionalInfoUuid,
      userData
    });
    return response.data;
  }

  /**
   * 生成样式文件
   * @param templateId 模板 ID
   * @param paperId
   * @param authors 元数据（作者信息）
   */
  public static async generatePdf(
    templateId: number,
    paperId: string,
    // authors: Author[]
  ): Promise<{
    pdf_url: string
    title: string
    latex_zip_url: string
    message: string
  }> {
    const response = await axios.post(BASE_URL + "/edit-api/paper/export/generator", {
     templateId,  paperId
    });
    return response.data;
  }

  /**
   * 下载文件
   * @param fileId 文件 ID
   */
  public static async downloadFile(fileId: string): Promise<Blob> {
    const response = await axios.get(BASE_URL + `/edit-api/paper/download/${fileId}`, { responseType: "blob" });
    return response.data;
  }
}

export default ExportService;
